import { optionsStackedBar } from "./utils"

// Stacked bar chart
const figure_3_2 = {
  type: "stacked",
  layout: "full",
  figureNumber: "3.2",
  title: "The IMF's Greenhouse Gas Emissions, Calendar Years 2012–21",
  subTitle: "(metric tons of carbon dioxide equivalent)",
  source: "Source: IMF, Corporate Services and Facilities Department.",
  customLegend: true,
  data: {
    labels: [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    datasets: [
      {
        label:
          "Scope 1: Mobile emissions, purchased fuel and fugitive emissions",
        borderColor: "#F1AF2A",
        backgroundColor: "#F1AF2A",
        data: [4808, 3890, 3553, 2539, 2142, 2265, 3107, 2894, 1711, 1896],
        barThickness: "flex",
        categoryPercentage: 0.9,
        maxBarThickness: 30,
      },
      {
        label: "Scope 2: Purchased electricity",
        borderColor: "#00568A",
        backgroundColor: "#00568A",
        data: [
          28610, 22194, 20903, 20770, 19784, 20046, 19632, 15244, 9973, 9637,
        ],
        barThickness: "flex",
        categoryPercentage: 0.9,
        maxBarThickness: 30,
      },
      {
        label:
          "Scope 3: Employee commuting, business travel, courier and shipments",
        borderColor: "#508C34",
        backgroundColor: "#508C34",
        data: [
          38467, 37995, 42932, 42844, 47586, 50004, 49998, 43362, 6851, 13887,
        ],
        barThickness: "flex",
        categoryPercentage: 0.9,
        maxBarThickness: 30,
      },
    ],
  },
  options: { ...optionsStackedBar, height: 'large', legend: { display: false } },
}

export default figure_3_2
